import { Injectable, Injector, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@core/auth.service';
import { map, Observable, of, Subject, switchMap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { v4 as uuidv4 } from "uuid";
import { CommonService } from '../../common/common.service';

@Injectable({
  providedIn: 'root'
})
export class RequestGameService implements OnDestroy {
  customerId: string;
  preferredCurrency: string;
  public checkApiPostReqProfileImg;
  public checkApiPostReqRemovePhoto;
  private destroy$ = new Subject<void>();

  constructor(private router: Router, private injector: Injector, private authService: AuthService, private commonService: CommonService) {
    this.checkApiPostReqProfileImg = false;
    this.checkApiPostReqRemovePhoto = false;
    this.preferredCurrency = "GBP";
    this.authService.getUid$("RequestGameService").pipe(
      switchMap(userId => {
        if (!userId) {
          return of(null); // or EMPTY if you want no emission
        }
        this.customerId = userId;
        return of(userId);
      })
    );
  }

  // This function is used to get the request body for to validate request is validate or not
  private validateRequest(): boolean {
    return true;
  }

  // This function validates the request and returns a boolean value. [this function is not call anywhere so comment it ]
  public playGameRequest(gameId: string): Observable<any> {
    return this.authService.getUid$("RequestGameService").pipe(
      map((uid) => {
        if (this.validateRequest()) {
          return {
            modules: [
              {
                action: "play_game",
                page_id: "3",
                screen_id: "3.2",
                module_name: "get_game_info",
                customer_id: uid, // use uid from auth
                game_id: gameId,
              },
            ],
            collection: `/users/${uid}/games_module`,
            mapKey: "game_id",
          };
        }
      })
    );
  }



  // This function is called when a customer purchases a game.
  // It sends a request to the customer_game_purchase module.
  public playGame(gameId) {
    if (this.validateRequest()) {
      return {
        modules: [
          {
            module_name: "customer_game_purchase",
            user_id: this.customerId,
            game_id: gameId,
            session_id: "CommonService.session.session_id",
          },
        ],
      };
    }
  }

  // This function is used to get the request body forget user games  [this function is not call anywhere so comment it ]
  public getGamesRequest(moduleName: string): Observable<any> {
    return this.authService.getUid$("RequestGameService").pipe(
      map((uid) => {
        if (this.validateRequest()) {
          return {
            modules: [
              {
                module_name: moduleName,
                customer_id: uid, // use uid from auth
              },
            ],
            collection: `/users/${uid}/games_module`,
          };
        }
      })
    );
  }


  // This function is used to get the request body for get user game slider details  [this function is not call anywhere so comment it ]
  public getGameSliderRequest(): Observable<any> {
    return this.authService.getUid$("RequestGameService").pipe(
      map((uid) => {
        if (this.validateRequest()) {
          return {
            modules: [
              {
                module_name: "get_your_game_list_game_slider",
                customer_id: uid, // use uid from auth
              },
            ],
            collection: `/users/${uid}/games_module`,
          };
        }
      })
    );
  }


  // This function is used to get the request body for get game purchase request  [this function is not call anywhere so comment it ]
  getGamePurchaseRequest(gameDetails, gameCount) {
    if (this.validateRequest()) {
      return {
        request: [
          {
            session_ID: "CommonService.session.session_id",
            action: "login_mobile_app",
            website: "Lotto Social",
            website_id: "33",
            source_site: "mobi.lottosocial.com",
            page_id: "3",
            screen_id: "3.7",
            module_name: "reward_payment_process",
            customer_id: this.customerId,
            product_name: gameDetails.product_name,
            product_detail: gameDetails.product_details,
            visitor_id: "",
            award_id: gameDetails.award_id,
            product_count: gameCount,
            price_per_product: gameDetails.product_price,
          },
        ],
      };
    }
  }


  // This function is used to get the request body for game purchase
  getPurchaseGameRequest(gameId: string) {
    if (this.validateRequest()) {
      return this.authService.getUid$("RequestGameService").pipe(
        map((userId) => {
          return {
            modules: [
              {
                module_name: "customer_game_purchase",
                user_id: userId,
                game_id: gameId,
                session_id: "mySessionId",
              },
            ],
          };
        })
      );
    }
  }


  getPurchaseFiebaseGameRequest(game: any): Observable<any> {
    return this.commonService.getUid("RequestGameService").pipe(
      map(uid => {
        const userId = uid || "";

        if (this.validateRequest()) {
          return {
            modules: [
              {
                module_name: "customer_game_token_authentication",
                user_id: userId,
                game_id: game?.category?.toLowerCase() !== "adventure" ? game?.game_id : "",
                adventure_id: game?.category?.toLowerCase() === "adventure" ? game?.adventure_id : "",
                platform_type: "app",
                source_site: environment.sourceSiteUrl,
                requestid: uuidv4(),
                document: game?.document ?? "/api_post_request/customer_game_token_authentication",
                from_page: game?.from_page ?? "",
              },
            ],
          };
        }
        return null;
      })
    );
  }

  // This function is used to get the request body for get unlock game description   [this function is not call anywhere so comment it ]
  getUnlockGameDescriptionRequest(gameId, customerAwardLogId) {
    if (this.validateRequest()) {
      return {
        request: [
          {
            module_name: "game_play",
            customerid: this.customerId,
            encrypt_gameid: gameId,
            encrypt_customerawardlogid: customerAwardLogId,
            session_id: "",
            methodname: "Method_0",
            platform_type: "app",
            country_code: "44",
          },
        ],
      };
    }
  }


  // This function is used to get the request body for get unlock game transaction id  [this function is not call anywhere so comment it ]
  getUnlockGameTransactionIdRequest(gameId, customerAwardLogId) {
    if (this.validateRequest()) {
      return {
        request: [
          {
            module_name: "game_play",
            customerid: this.customerId,
            encrypt_gameid: gameId,
            encrypt_customerawardlogid: customerAwardLogId,
            session_id: "",
            methodname: "Method_1",
            platform_type: "app",
            country_code: "44",
          },
        ],
      };
    }
  }

  // This function is used to get the request body for get unlock game status   [this function is not call anywhere so comment it ]
  getUnlockGameStatusRequest(transactionId, spot, time) {
    if (this.validateRequest()) {
      return {
        request: [
          {
            module_name: "game_play",
            transaction_id: transactionId,
            encrypt_customertournamentid: "",
            encrypt_game_target_id: "",
            session_id: "",
            customerid: this.customerId,
            methodname: "Method_2",
            platform_type: "app",
            country_code: "44",
            targets: { spot: spot },
            restrictions: { time: time },
          },
        ],
      };
    }
  }
  // This function is used to get the request body for get unlock game to play  [this function is not call anywhere so comment it ]
  getUnlockGamesListRequest() {
    if (this.validateRequest()) {
      return {
        request: [
          {
            module_name: "unlock_games_to_play",
            customer_id: this.customerId,
          },
        ],
      };
    }
  }

  // The ngOnDestroy() method, we emit a value and complete the destroy$ subject, which unsubscribes from the observable.
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }






}


